export const networkClassNameMap = {
  'Adult Swim': 'network-banner__description--adult-swim',
  ABC: 'network-banner__description--abc',
  BET: 'network-banner__description--bet',
  CBS: 'network-banner__description--cbs',
  'Comedy Central': 'network-banner__description--comedy-central',
  'Cooking Channel': 'network-banner__description--cooking-channel',
  CNN: 'network-banner__description--cnn',
  'Destination America': 'network-banner__description--destination-america',
  'Discovery Channel': 'network-banner__description--discovery-channel',
  'Discovery en Español': 'network-banner__description--discovery-spanish',
  'Discovery Family': 'network-banner__description--discovery-family',
  'Disney Junior': 'network-banner__description--disney-junior',
  'E!': 'network-banner__description--e-network',
  ESPN: 'network-banner__description--espn',
  'Food Network': 'network-banner__description--food-network',
  'Fox Deportes': 'network-banner__description--fox-deportes',
  'Fox Sports 1': 'network-banner__description--fox-sports-one',
  'Golf Channel': 'network-banner__description--golf-channel',
  Max: 'network-banner__description--max',
  Kabillion: 'network-banner__description--kabillion',
  KLIFE: 'network-banner__description--klife',
  Lifetime: 'network-banner__description--lifetime',
  Logo: 'network-banner__description--logo',
  'Magnolia Network': 'network-banner__description--magnolia',
  'Military History': 'network-banner__description--military-history',
  'MLB Network': 'network-banner__description--mlb',
  MotorTrend: 'network-banner__description--motortrend',
  Movieplex: 'network-banner__description--movieplex',
  MSNBC: 'network-banner__description--msnbc',
  'National Geographic': 'network-banner__description--national-geographic',
  'National Geographic Wild':
    'network-banner__description--national-geographic-wild',
  'Nick at Night': 'network-banner__description--nick-at-night',
  'Nick En Español': 'network-banner__description--nick-in-spanish',
  'Nick Jr.': 'network-banner__description--nick-jr',
  Nickelodeon: 'network-banner__description--nickelodeon',
  OWN: 'network-banner__description--own',
  Reelz: 'network-banner__description--reelz',
  Revolt: 'network-banner__description--revolt',
  Showtime: 'network-banner__description--showtime',
  Shudder: 'network-banner__description--shudder',
  STARZ: 'network-banner__description--starz',
  'STARZ ENCORE': 'network-banner__description--starz-encore',
  'Sundance TV': 'network-banner__description--sundance',
  TUDN: 'network-banner__description--tudn',
  'TV One': 'network-banner__description--tv-one',
};
